import { Button, Grid, Typography } from '@mui/material'
import React from 'react'

const DeletePage = ({onSubmit, onCancel}) => {
  return (
    <Grid className='bg-white p-5'>
        <Typography variant='h5'>Are you sure want to delete?</Typography>
        <Grid className='flex justify-center mt-5'>
            <Button variant='outlined' onClick={()=> onCancel(false)}>Cancel</Button>
            <Button variant='contained' sx={{marginInline: 2, backgroundColor:'red !important'}} onClick={onSubmit}>Delete</Button>
        </Grid>
    </Grid>
  )
}

export default DeletePage